export const DEAL_SOURCE_VALUES = ['manual', 'inbound', 'campaign', 'lead'];
export const DEAL_SOURCE_LABELS = {
    manual: 'Handmatig',
    inbound: 'Inbound',
    campaign: 'Campagne',
    lead: 'Lead',
};
export const DEAL_LOST_REASON_VALUES = [
    'price',
    'timing',
    'competitor',
    'no_budget',
    'no_fit',
    'ghosted',
    'other',
];
export const DEAL_LOST_REASON_LABELS = {
    price: 'Prijs',
    timing: 'Timing',
    competitor: 'Concurrent',
    no_budget: 'Geen budget',
    no_fit: 'Geen fit',
    ghosted: 'Geen reactie',
    other: 'Overig',
};
//# sourceMappingURL=dealSources.js.map